export default __webpack_public_path__ + "static/media/crypto-treasury.24d9a8f9.png";